<template>
  <v-card class="rounded-lg">
    <v-card-title class="secondary--text">{{title}}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <ware-select v-model="ware" label="نام کالا" @change="o => filters.ware = o.id"/>
        </v-col>
        <v-col cols="12" md="4">
          <ware-select
              v-model="ware"
              label="کد کالا"
              @change="o => filters.ware = o.id"
              :show-info="false"
              with-code="true"
          />
        </v-col>
        <v-col cols="12" md="4">
          <warehouse-select
              class="rounded-lg"
              :return-object="false"
              label="انبار"
              :items="warehouses"
              v-model="filter_warehouses"
              item-text="title"
              item-value="id"
              multiple
              clearable
              @input="setFilterWithWarehouses"
          >
          </warehouse-select>
        </v-col>
        <v-col cols="12">
          <m-datatable
              v-if="filters.ware"
              :api-url="url"
              :headers="headers"
              :filters.sync="filters"
              ref="datatable"
          >
            <template #item.factor.code="{ item }">
              <v-btn v-if="item.factor.code >= 0" text depressed color="info" icon rounded :to="goToFactor(item)"
              >{{ item.factor.code }}
              </v-btn>
              <v-btn v-else text depressed color="info" icon rounded @click="getToFpi(item)"
              >{{ item.factor.code }}
              </v-btn>
            </template>


          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import wareApiMixin from "@/mixin/wareApi";
import _ from "lodash";
import WarehouseSelect from "@/components/selects/WarehouseSelect";

export default {
  mixins: [wareApiMixin],
  components: {WarehouseSelect },
  data() {
    return {
      ware: null,
      url: "reports/inventory/warehouse",
      filter_warehouses: [0],
      headers: [
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
          sortable: false,
        },
        {
          text: "نوع عملیات",
          value: "factor_type",
          sortable: false,
        },
        {
          text: "شماره عملیات",
          value: "factor.code",
          type: "numeric",
          sortable: false,
        },
        {
          text: "شرح عملیات",
          value: "factor.explanation",
          sortable: false,
        },
        {
          text: "انبار",
          value: "warehouse.name",
          sortable: false,
        },
        {
          text: "نام حساب",
          value: "factor.account.name",
          sortable: false,
        },
        {
          text: "وارده",
          value: "input",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "صادره",
          value: "output",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مانده",
          value: "remain",
          type: "numeric",
          sortable: false,
          filterable: false,
        },

      ],
      filters: {
        ware: null,
        warehouse: null,
      },
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('کاردکس انبار')
    }
  },
  created() {
    this.getWarehouses();
  },
  methods: {
    getToFpi(item) {
      this.$router.push("/panel/factor/form/false/fpi/" + item.factor.id);
    },
    goToFactor(item) {
      let factor = item.factor;
      return {
        name: "FactorForm",
        params: {
          id: factor.id,
          type: factor.type,
          isPreFactor: factor.is_pre_factor,
        },
      };
    },

    setFilterWithWarehouses(inventoryWare) {
      let warehouses_string = this.filter_warehouses.join(",");
      if (warehouses_string != "0") {
        this.filters.warehouse_in = warehouses_string;
      } else {
        this.filters.warehouse_in = undefined;
      }
      this.$refs.datatable && this.$refs.datatable.getDataFromApi();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
